import { useMutation, Context } from '@apollo/client'
import { useUserId } from '@/redux/userProfile/selectors'
import ApplyCodeMutation from '@/mutations/applyCode'
import { REDEMPTION_TYPE } from '@/constants'

interface redeemCodeProps {
  code: string
  userId?: number | string
  context?: Context
}

const useApplyCode = () => {
  const [applyCode] = useMutation(ApplyCodeMutation)
  const loggedInUserId = useUserId()

  const redeemCode = ({ code, userId, context }: redeemCodeProps) =>
    applyCode({
      variables: {
        patient_id: Number(userId || loggedInUserId),
        code,
        redemption_type: REDEMPTION_TYPE,
      },
      ...(context && { context }),
    })

  return { redeemCode }
}

export default useApplyCode
